import defaultMenuRenderer from 'react-select/lib/utils/defaultMenuRenderer';
import selectMenuFactory from './select-menu-factory';

const SelectMenuStandard = selectMenuFactory(defaultMenuRenderer);

export default SelectMenuStandard;
export { SelectMenuStandard };
